import { Link } from 'react-router-dom';
import React, { useState, useEffect, useContext } from "react";
import classes from './MainNavigation.module.css';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import SmartSensingLogo from './SmartSensing.png';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import HomeIcon from '@mui/icons-material/Home';
import HelpIcon from '@mui/icons-material/Help';
import AuthService from "../../services/auth.service";
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import DeleteIcon from '@mui/icons-material/Delete';
import LocaleContext from '../../LocaleContext';
import TranslateIcon from '@mui/icons-material/Translate';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import { useTranslation } from "react-i18next";
import i18n from '../../i18n';


const pages = ['Products', 'Pricing', 'Blog'];
const styles = {
  appBar: {
    backgroundColor: 'white',
    color: '#1061af'// Set your desired color here
  },
};

 function MainNavigation() {
  const { locale } = useContext(LocaleContext);
  const [showModeratorBoard, setShowModeratorBoard] = useState(false);
  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [currentUser, setCurrentUser] = useState(undefined);

  const { t } = useTranslation("common");

  function changeLocale(l) {
    if (locale !== l) {
      i18n.changeLanguage(l);
    }
  }

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setCurrentUser(user);
      setShowModeratorBoard(user.roles.includes("ROLE_MODERATOR"));
      setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
    }
  }, []);
  const logOut = () => {
    AuthService.logout();
  };

   return (
     <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" style={styles.appBar}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
          >
            <img src={SmartSensingLogo} width='100' />
          </IconButton>
          <Button href='/' color="inherit" sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} startIcon={<HomeIcon />}>{t('toolbar.home')}</Button>

           <Button href='https://www.linkedin.com/company/smart2sensing/' color="inherit" sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} startIcon={<LinkedInIcon />}>{t('toolbar.linkedin')}</Button>
           
          {!(locale == 'en') && <Button onClick={() => changeLocale('en')} color="inherit" sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' } }} startIcon={<TranslateIcon />}>{t('toolbar.language')}</Button>}
          {locale == 'en' && <Button onClick={() => changeLocale('pl')} color="inherit" sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' } }} startIcon={<TranslateIcon />}>{t('toolbar.language')}</Button>}


        </Toolbar>

      </AppBar>

    </Box>



  );







 }

 export default MainNavigation;
